import i18n from 'i18nextInstance';

export const HEADERS = {
    admission_date: i18n.t('Fecha de ingreso'),
    affiliate_number: i18n.t('Afiliado'),
    appointment_date: i18n.t('Fecha del turno'),
    appointment_time: i18n.t('Hora del turno'),
    area: i18n.t('Zona'),
    birth_date: i18n.t('Fecha de Nacimiento'),
    cellphone_number: i18n.t('Teléfono'),
    cost_center: i18n.t('Centro de costos'),
    coverage: i18n.t('Cobertura'),
    doctors_related: i18n.t('Profesionales asociados'),
    email: i18n.t('Email'),
    enabled: i18n.t('Habilitado'),
    family_burden: i18n.t('Carga de familia'),
    file_number: i18n.t('Legajo'),
    first_name: i18n.t('Nombre'),
    gender: i18n.t('Sexo'),
    hr_head: i18n.t('Jefe de RRHH'),
    identification: i18n.t('DNI'),
    last_name: i18n.t('Apellido'),
    plan: i18n.t('Plan'),
    position: i18n.t('Cargo'),
    schedule: i18n.t('Régimen laboral'),
    supervisor_identification: i18n.t('DNI del supervisor'),
    workplace: i18n.t('Lugar de trabajo')
};

export const HELP_ITEMS = [{
    key: 'birth_date',
    label: i18n.t('Fecha de nacimiento'),
    text: i18n.t('DD/MM/AAAA')
}, {
    key: 'gender',
    label: i18n.t('Sexo'),
    text: i18n.t('M o F')
}, {
    key: 'doctors_related',
    label: i18n.t('Profesionales'),
    text: i18n.t('DNI separados por comas')
}, {
    key: 'cellphone_number',
    label: i18n.t('Celular'),
    text: i18n.t('opcional')
}, {
    key: 'enabled',
    label: i18n.t('Habilitado'),
    text: `${ i18n.t('Si') }/${ i18n.t('No') }`
}, {
    key: 'coverage',
    label: i18n.t('Cobertura'),
    text: i18n.t('Existente en la plataforma')
}, {
    key: 'plan',
    label: i18n.t('Plan'),
    text: i18n.t('Existente en la cobertura ingresada')
}, {
    key: 'appointment_date',
    label: i18n.t('Fecha del turno'),
    text: i18n.t('DD/MM/AAAA')
}, {
    key: 'appointment_time',
    label: i18n.t('Hora del turno'),
    text: i18n.t('HH:MM')
}];
